module.exports = __webpack_public_path__ + "img/戴尔.a3368d98.png";